import { VehicleSpecificationProps } from "./types";
import {
    VehicleHeader,
    VehicleTypeSection,
    VehicleBasicInfo,
    VehicleRegistration,
    VehicleInsurance,
    VehicleWarranty,
} from "./components";

const VehicleSpecification: React.FC<VehicleSpecificationProps> = (props) => {
    const { fleetVehicleDetail, onMileageUpdate, onRegistrationUpdate } = props;

    return (
        <>
            <VehicleHeader fleetVehicleDetail={fleetVehicleDetail} />
            <VehicleTypeSection fleetVehicleDetail={fleetVehicleDetail} />
            <VehicleBasicInfo fleetVehicleDetail={fleetVehicleDetail} onMileageUpdate={onMileageUpdate} />
            <VehicleRegistration fleetVehicleDetail={fleetVehicleDetail} onRegistrationUpdate={onRegistrationUpdate} />
            <VehicleInsurance fleetVehicleDetail={fleetVehicleDetail} />
            <VehicleWarranty fleetVehicleDetail={fleetVehicleDetail} />
        </>
    );
};

export default VehicleSpecification;
